var _excluded = ["origin"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

export var initialState = {
  'right-top': [],
  'right-bottom': [],
  'center-top': []
};
export var toastReducer = (state, _ref) => {
  var {
    type,
    payload
  } = _ref;

  var {
    origin
  } = payload,
      restPayload = _objectWithoutPropertiesLoose(payload, _excluded);

  switch (type) {
    case 'ADD_TOAST':
      return _extends({}, state, {
        [origin]: [...state[origin], restPayload]
      });

    case 'REMOVE_TOAST':
      {
        return _extends({}, state, {
          [origin]: state[origin].filter(toast => {
            /* istanbul ignore else */
            if (toast._id === restPayload._id) clearTimeout(toast.timer);
            return toast._id !== restPayload._id;
          })
        });
      }

    case 'CLOSE_ALL_TOASTS':
      {
        var toastsToClose = Object.values(state).reduce((acc, toasts) => acc.concat(toasts), []);
        toastsToClose.forEach(toast => {
          clearTimeout(toast.timer);
        });
        return initialState;
      }

    default:
      return state;
  }
};
//# sourceMappingURL=toast-reducer.js.map